<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.edit' | translate }}
    v-card-content
      v-input.mb-3(
        :label="$t('base.name')"
        :focus="true"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="currentCompany.name")
      v-select.mb-3(
        :label="$t('base.type')"
        item-text="name"
        item-value="id"
        :options="deliveryTypes"
        v-model="currentCompany.side")
      v-input.mb-3(
        :label="$t('base.information')"
        v-model="currentCompany.description")
      v-input(
        :label="$t('base.edrpu')"
        :hint="errorMessage('ind_code')"
        :invalid="!!errorMessage('ind_code')"
        v-model="currentCompany.ind_code")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onSave")
        | {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import { mapGetters, mapActions } from 'vuex'

import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'EditModal',
  mixins: [formErrorsMixin],
  components: {
    DeleteBtn
  },

  data: () => ({
    deliveryTypes: [
      { id: 'seller', name: 'base.seller' },
      { id: 'buyer', name: 'base.buyer' }
    ],
    loading: false,
    errors: {
      name: null,
      ind_code: null
    },
  }),

  methods: {
    ...mapActions('deliveries', [
      'saveCompanyDetail',
      'deleteCompany'
    ]),

    async onSave () {
      this.loading = true
      const { id, ...payload } = this.currentCompany

      this.checkValidData()
      if (this.errors.name === null && this.errors.ind_code === null) {
        const { errors } = await api.deliveries.companies.updateById(id, payload)
        this.errors = errors
        if (!errors) {
          await this.saveCompanyDetail()
        }
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      this.errors.ind_code = null

      const isUS = this.$store.getters['account/lang'] === 'us'

      // Validate name
      if (!this.currentCompany.name) {
        this.errors.name = ['3']
      } else if (this.currentCompany.name.length > 100) {
        this.errors.name = ['6', 100]
      }

      // Validate ind_code
      if (!this.currentCompany.ind_code || this.currentCompany.ind_code.length === 0) {
        this.errors.ind_code = ['3']
      } else if (isUS) {
        // US: must be exactly 9 digits
        if (!/^\d{9}$/.test(this.currentCompany.ind_code)) {
          this.errors.ind_code = ['6', 9]
        }
      } else {
        // Others: must be 8 to 12 digits
        if (!/^\d{8,12}$/.test(this.currentCompany.ind_code)) {
          this.errors.ind_code = ['6', 12]
        } else if (this.currentCompany.ind_code.length < 8 || this.currentCompany.ind_code.length > 12) {
          this.errors.ind_code = ['6', 12]
        }
      }
    },
    onDelete () {
      this.deleteCompany()
    }
  },

  computed: {
    ...mapGetters('deliveries', [
      'currentCompany'
    ])
  }
}
</script>
